/* ReactionsDialog.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./ReactionsDialog.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect, useState, useCallback, useMemo } from 'react';
import Tabs from '@atlaskit/tabs';
import Modal, { ModalBody } from '@atlaskit/modal-dialog';
import { Box } from '@atlaskit/primitives/compiled';
import { NUMBER_OF_REACTIONS_TO_DISPLAY } from '../../shared/constants';
import { ReactionsList } from './ReactionsList';
import { ReactionsDialogHeader } from './ReactionsDialogHeader';
var styles = {
  modalBodyStyle: "_otyr1ejb"
};

/* Reactions Container. Using pseudo Element :after to set border since with onClick of Reaction to higlight the
border blue below the reaction. */
var containerStyle = null;

/**
 * Test id for the Reactions modal dialog
 */
export var RENDER_MODAL_TESTID = 'render-reactions-modal';
export var ReactionsDialog = function ReactionsDialog(_ref) {
  var _currentReactions$;
  var _ref$reactions = _ref.reactions,
    reactions = _ref$reactions === void 0 ? [] : _ref$reactions,
    _ref$handleCloseReact = _ref.handleCloseReactionsDialog,
    handleCloseReactionsDialog = _ref$handleCloseReact === void 0 ? function () {} : _ref$handleCloseReact,
    emojiProvider = _ref.emojiProvider,
    selectedEmojiId = _ref.selectedEmojiId,
    _ref$handleSelectReac = _ref.handleSelectReaction,
    handleSelectReaction = _ref$handleSelectReac === void 0 ? function () {} : _ref$handleSelectReac,
    _ref$handlePagination = _ref.handlePaginationChange,
    handlePaginationChange = _ref$handlePagination === void 0 ? function () {} : _ref$handlePagination,
    ProfileCardWrapper = _ref.ProfileCardWrapper;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasNavigatedPages = _useState2[0],
    setHasNavigatedPages = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];
  var totalReactionsCount = useMemo(function () {
    return reactions.reduce(function (accum, current) {
      return accum += current === null || current === void 0 ? void 0 : current.count;
    }, 0);
  }, [reactions]);
  var maxPages = Math.max(1, Math.ceil(reactions.length / NUMBER_OF_REACTIONS_TO_DISPLAY));
  var currentReactions = useMemo(function () {
    var start = (currentPage - 1) * NUMBER_OF_REACTIONS_TO_DISPLAY;
    var end = start + NUMBER_OF_REACTIONS_TO_DISPLAY;
    return reactions.slice(start, end);
  }, [reactions, currentPage]);
  var handleNextPage = function handleNextPage() {
    setCurrentPage(function (prevPage) {
      return Math.min(prevPage + 1, maxPages);
    });
    setHasNavigatedPages(true);
  };
  var handlePreviousPage = function handlePreviousPage() {
    setCurrentPage(function (prevPage) {
      return Math.max(prevPage - 1, 1);
    });
    setHasNavigatedPages(true);
  };
  var firstEmojiOnPage = (_currentReactions$ = currentReactions[0]) === null || _currentReactions$ === void 0 ? void 0 : _currentReactions$.emojiId;
  useEffect(function () {
    // trigger the handler with the first emoji when the page changes
    if (hasNavigatedPages && firstEmojiOnPage) {
      handlePaginationChange(firstEmojiOnPage, currentPage, maxPages);
    }
  }, [hasNavigatedPages, currentPage, maxPages, firstEmojiOnPage, handlePaginationChange]);
  var selectedIndex = currentReactions.findIndex(function (reaction) {
    return reaction.emojiId === selectedEmojiId;
  });
  var onTabChange = useCallback(function (index) {
    if (index === selectedIndex) {
      return;
    }
    var emojiId = currentReactions[index].emojiId;
    handleSelectReaction(emojiId);
  }, [selectedIndex, currentReactions, handleSelectReaction]);
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: handleCloseReactionsDialog,
    height: 600,
    testId: RENDER_MODAL_TESTID
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: false
  }, /*#__PURE__*/React.createElement(Tabs, {
    id: "reactions-dialog-tabs",
    onChange: onTabChange,
    selected: selectedIndex
  }, /*#__PURE__*/React.createElement(ReactionsDialogHeader, {
    totalReactionsCount: totalReactionsCount,
    maxPages: maxPages,
    handlePreviousPage: handlePreviousPage,
    handleNextPage: handleNextPage,
    currentPage: currentPage,
    emojiProvider: emojiProvider,
    currentReactions: currentReactions,
    handleCloseReactionsDialog: handleCloseReactionsDialog
  }), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.modalBodyStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_1reo15vq _18m915vq _4t3i1osq _1e0c1txw _1bahv2br _kqswh2mm _1dm8q5uf _aetrb3bt _1bqqidpf _1ywu1ule _1yd81osq _1x88idpf _18postnw"])
  }, /*#__PURE__*/React.createElement(ReactionsList, {
    selectedEmojiId: selectedEmojiId,
    reactions: currentReactions,
    ProfileCardWrapper: ProfileCardWrapper
  }))))));
};